import { styled } from "@mui/material";

const Wrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  height: "100%",
  justifyContent: "space-between",
});

export const Styles = {
  Wrapper,
};
